export default {
	abas: [
		{ nome: 'Notificacoes', titulo: 'Notificações', isVisivel: true },
		{ nome: 'Itens', titulo: 'Itens', isVisivel: false },
		{ nome: 'Documentos', titulo: 'Documentos', isVisivel: false },
		{ nome: 'Sancao', titulo: 'Sanções', isVisivel: true },
	],
	orgaoSancionadorSalvo: null,
	fornecedorSalvo: null,
	idPenalidadeSalva: null,
	abaSelecionada: null,
	salvarSancaoPenalidade: 0,
	efetivarSancaoPenalidade: 0,
	isPenalidadeEfetivada: false,
	salvarItensPenalidade: 0,
	inserirNotificacaoPenalidade: 0,
}
